const vehicleTransportsDistances = [0, 50, 100, 200];

export default vehicleTransportsDistances;
